import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService, SessionState } from './services/session.service';
import { TranslateService } from '@ngx-translate/core';
import { skip } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'photoUpload';
  routeChangeSubscription: Subscription;
  requestedLanguage: any;

  state: 'loading' | 'content' | 'error' | 'nosession' = 'loading';

  constructor(private router: Router,
    private route: ActivatedRoute,
    public sessionService: SessionService,
    protected http: HttpClient,
    public translate: TranslateService) {
    translate.addLangs(['en', 'de']);
    translate.setDefaultLang('de');

    const browserLang = translate.getBrowserLang();


    this.routeChangeSubscription = this.route.queryParamMap
      .subscribe(async params => {
        this.state = 'nosession';
        await this.sessionService.loadConnectorEndpoint();
        try {
          if (params.has('lang')) {
            this.requestedLanguage = params.get('lang');
            if (this.requestedLanguage == 'en') {
              translate.use('en');
            }
            else if (this.requestedLanguage == 'de') {
              translate.use('de');
            }
            else {
              translate.use('de');
            }
          }
          if (params.has('session')) {
            this.state = 'loading';
            const sessionId = params.get('session');
            await this.sessionService.loadSession(sessionId);

            console.log('session', this.sessionService.session);
            if (this.sessionService.session?.state !== SessionState.Active) {
              this.state = 'error';
            } else {
              this.state = 'content';
            }

          } else {
            this.state = 'nosession';

            setTimeout(() => {
              if(this.state === 'nosession'){
                this.state = 'error';
              }
            }, 2000)
          }
        } catch (ex) {
          console.error(ex);

          this.state = 'error';
        }
      });
  }
}
